export default function getBestDeal(availableProducts: Product[]) {
  if (availableProducts.length <= 1 || availableProducts.length === 0) {
    return null;
  }
  const pricesPerDay: number[] = [];
  let indexOfBestDeal;
  availableProducts.forEach(({ period, duration, price }) => {
    let days = 0;
    if (period === "day") days = 1 * duration;
    if (period === "week") days = 7 * duration;
    if (period === "month") days = 31 * duration;
    if (period === "year") days = 365 * duration;
    pricesPerDay.push(price / days);
  });
  const highestPerDay = Math.max(...pricesPerDay);
  const lowestPerDay = Math.min(...pricesPerDay);
  if (lowestPerDay === highestPerDay) return null;
  pricesPerDay.forEach((price) => {
    if (price === lowestPerDay) {
      indexOfBestDeal = pricesPerDay.indexOf(price);
    }
  });
  const difference = (lowestPerDay / highestPerDay) * 100;
  const roundedDifference = 100 - Math.round(difference);
  return { difference: roundedDifference, indexOfBestDeal };
}
